//register/login/logout actions
//We also need to use Redux Toolkit createAsyncThunk which provides a thunk that will take care of the action types and dispatching the right actions based on the returned promise.
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setMessage } from "./message";

import AuthService from "../services/auth.service";

const user = JSON.parse(localStorage.getItem("user"));

export const register = createAsyncThunk(
  "auth/register",
  async ({ username, email, password }, thunkAPI) => {
    try {
      const response = await AuthService.register(username, email, password);
      thunkAPI.dispatch(setMessage(response.data.message));
      return response.data;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const login = createAsyncThunk(
    "auth/login",
    async ({ username, password }, thunkAPI) => {
      try {
        const data = await AuthService.login(username, password);
        return { user: data };
      } catch (error) {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        thunkAPI.dispatch(setMessage(message));
        return thunkAPI.rejectWithValue();
      }
    }
  );

  export const logout = createAsyncThunk("auth/logout", async () => {
    await AuthService.logout();
  });
  
  const initialState = user
    ? { isLoggedIn: true, user }
    : { isLoggedIn: false, user: null };

    const authSlice = createSlice({
        name: "auth",
        initialState,
        extraReducers:(builder) => {
          builder
                .addCase(register.fulfilled, (state, action) => {
                  state.isLoggedIn = false;
                })
                .addCase(register.rejected, (state, action) => {
                  state.isLoggedIn = false;
                })
                .addCase(login.rejected, (state, action) => {
                  state.isLoggedIn = false;
                  state.user = null;
                })
                .addCase(logout.fulfilled, (state, action) => {
                  state.isLoggedIn = false;
                  state.user = null;
                })
        }
        // extraReducers: {
        //   [register.fulfilled]: (state, action) => {
        //     state.isLoggedIn = false;
        //   },
        //   [register.rejected]: (state, action) => {
        //     state.isLoggedIn = false;
        //   },
        //   [login.rejected]: (state, action) => {
        //     state.isLoggedIn = false;
        //     state.user = null;
        //   },
        //   [logout.fulfilled]: (state, action) => {
        //     state.isLoggedIn = false;
        //     state.user = null;
        //   },
        // },
        // extraReducers: {
        //   [register.fulfilled]: (state, action) => {
        //     state.isLoggedIn = false;
        //   },
        //   [register.rejected]: (state, action) => {
        //     state.isLoggedIn = false;
        //   },
        //   [login.rejected]: (state, action) => {
        //     state.isLoggedIn = false;
        //     state.user = null;
        //   },
        //   [logout.fulfilled]: (state, action) => {
        //     state.isLoggedIn = false;
        //     state.user = null;
        //   },
        // },
    });

    const { reducer } = authSlice;
    export default reducer;
        